import { Button, Typography } from '@mui/material';
import { PersonOutline as PersonOutlineIcon } from '@mui/icons-material';
import { useState } from 'react';

import { colors } from 'styles/theme/colors';
import { useServerTranslation } from 'hooks/useServerTranslation';
import LoginDialog from '../User/LoginDialog/LoginDialog';

export function LogInButton() {
    const { t } = useServerTranslation();
    const [openLogin, setOpenLogin] = useState(false);
    const openLoginDialog = () => {
        setOpenLogin(true);
    };

    return (
        <>
            <Button
                variant="black"
                size="small"
                onClick={openLoginDialog}
                sx={{
                    borderRadius: { xs: '50%', md: '2px' },
                    padding: '6px',
                    '&:hover': { backgroundColor: { md: colors.white }, color: { md: colors.pink2 } },
                }}
            >
                <Typography
                    sx={{
                        component: 'div',
                        marginRight: 0.5,
                        display: { xs: 'none', md: 'inline-block' },
                    }}
                >
                    {t('menu.log-in')}
                </Typography>
                <PersonOutlineIcon />
            </Button>
            <LoginDialog open={openLogin} setOpen={setOpenLogin} />
        </>
    );
}
